
import Vue, { PropType } from 'vue'

const LETTER_RE = /[A-Za-zА-Яа-яЁё]/
const NUMBER_RE = /\d/

type FieldKey = 'current' | 'new' | 'confirm'

export default Vue.extend({
    name: 'ChangePasswordDialog',
    props: {
        value: { type: Boolean as PropType<boolean> },
    },
    data: () => ({
        view: 'form' as 'form' | 'success',
        showCurrent: false,
        showNew: false,
        showConfirm: false,
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
        fieldErrors: {} as Record<string, string>,
        loading: false,
    }),
    computed: {
        isDialog: {
            get(): boolean {
                return this.value
            },
            set(value: boolean): void {
                this.$emit('input', value)
            },
        },
        checks(): { length: boolean; letter: boolean; number: boolean; different: boolean } {
            const value = this.newPassword
            return {
                length: value.length >= 8,
                letter: LETTER_RE.test(value),
                number: NUMBER_RE.test(value),
                different: value.length > 0 && value !== this.currentPassword,
            }
        },
    },
    watch: {
        isDialog(open: boolean) {
            if (open) this.init()
        },
    },
    methods: {
        init() {
            this.view = 'form'
            this.showCurrent = false
            this.showNew = false
            this.showConfirm = false
            this.currentPassword = ''
            this.newPassword = ''
            this.confirmPassword = ''
            this.fieldErrors = {}
            this.loading = false
        },
        close() {
            if (this.loading) return
            this.isDialog = false
        },
        stripSpaces(value: string) {
            return String(value || '').replace(/\s/g, '')
        },
        clearFieldError(field: FieldKey) {
            if (!this.fieldErrors[field]) return
            const next = { ...this.fieldErrors }
            delete next[field]
            this.fieldErrors = next
        },
        onPasswordInput(field: FieldKey, event: Event) {
            const target = event.target as HTMLInputElement
            const cleaned = this.stripSpaces(target.value)

            if (field === 'current') this.currentPassword = cleaned
            else if (field === 'new') this.newPassword = cleaned
            else this.confirmPassword = cleaned

            this.clearFieldError(field)

            if (target.value !== cleaned) {
                target.value = cleaned
            }
        },
        validate(): boolean {
            const errors: Record<string, string> = {}
            const { length, letter, number, different } = this.checks

            if (!this.currentPassword.trim()) {
                errors.current = 'Введите текущий пароль.'
            }

            if (!length || !letter || !number || !different) {
                errors.new = 'Проверьте новый пароль. Он не соответствует требованиям.'
            }

            if (!this.confirmPassword.trim()) {
                errors.confirm = 'Повторите новый пароль.'
            } else if (this.confirmPassword !== this.newPassword) {
                errors.confirm = 'Пароли не совпадают.'
            }

            this.fieldErrors = errors
            return Object.keys(errors).length === 0
        },
        async submit() {
            if (!this.validate() || this.loading) return

            this.loading = true
            const { error } = await this.$auth.changePassword(
                this.$auth.user.sub,
                this.currentPassword,
                this.newPassword
            )
            this.loading = false

            if (error) {
                this.fieldErrors = { current: error.message || 'Не удалось сменить пароль.' }
                return
            }

            this.view = 'success'
        },
    },
})
